import React, {useState, useEffect, useRef} from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronDown,faChevronUp
} from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

//Graphics
import instagram from "../assets/graphics/Instagram.png"
import tour from "../assets/graphics/tourIcon.png"
import email from "../assets/graphics/email-icon.png"

import "../styling/FAQ.scss";

function FAQ() {
    const [navClicked1, setNavClicked1] = useState(false);
    const [navClicked2, setNavClicked2] = useState(false);
    const [navClicked3, setNavClicked3] = useState(false);
    const [navClicked4, setNavClicked4] = useState(false);
    const [navClicked5, setNavClicked5] = useState(false);
    const [navClicked6, setNavClicked6] = useState(false);
    const [navClicked7, setNavClicked7] = useState(false);

    const location = useLocation();
    const elementRef = useRef(null);

    useEffect(
        function () {
            if (location.pathname === "/faq") {
                elementRef.current.scrollIntoView({
                    behavior: "smooth",
                });
            }
            // setSignUp(false);
        },
        [location]
    );
    
  return (
      <div className="FAQPage" ref={elementRef}>
          <section>
              <div className="wrapper">
                  <div className="questionList">
                      <h2>Frequently Asked Questions</h2>
                      <div className="questionContainer">
                          <div className="question">
                              <p>How do I sign up for a membership?</p>
                              <FontAwesomeIcon
                                  onClick={() => setNavClicked1(!navClicked1)}
                                  icon={
                                      navClicked1 ? faChevronUp : faChevronDown
                                  }
                                  className="dropDownIcon"
                              />
                          </div>
                          {navClicked1 ? (
                              <p className="answer">
                                  We offer free 30 minute tours. You can book
                                  your tour{" "}
                                  <a href="mailto:marketing@pltfrm.fit.">
                                      marketing@pltfrm.fit.
                                  </a>
                              </p>
                          ) : (
                              <></>
                          )}
                      </div>
                      <div className="questionContainer">
                          <div className="question">
                              <p>Can I tour PLTFRM in person?</p>
                              <FontAwesomeIcon
                                  onClick={() => setNavClicked2(!navClicked2)}
                                  icon={
                                      navClicked2 ? faChevronUp : faChevronDown
                                  }
                                  className="dropDownIcon"
                              />
                          </div>
                          {navClicked2 ? (
                              <p className="answer">
                                  We offer free 30 minute tours. You can book
                                  your tour{" "}
                                  <a href="https://calendly.com/pltfrm-fit/30mintour">
                                      here
                                  </a>{" "}
                                  or reach out to our team at{" "}
                                  <a href="mailto:marketing@pltfrm.fit">
                                      marketing@pltfrm.fit
                                  </a>
                                  .
                              </p>
                          ) : (
                              <></>
                          )}
                      </div>
                      <div className="questionContainer">
                          <div className="question">
                              <p>Do you have showers on site?</p>
                              <FontAwesomeIcon
                                  onClick={() => setNavClicked3(!navClicked3)}
                                  icon={
                                      navClicked3 ? faChevronUp : faChevronDown
                                  }
                                  className="dropDownIcon"
                              />
                          </div>
                          {navClicked3 ? (
                              <p className="answer">
                                  We have bathrooms, a changing room, and a
                                  shower on site.
                              </p>
                          ) : (
                              <></>
                          )}
                      </div>
                      <div className="questionContainer">
                          <div className="question">
                              <p>
                                  How do I reserve training slots or book
                                  classes?
                              </p>
                              <FontAwesomeIcon
                                  onClick={() => setNavClicked4(!navClicked4)}
                                  icon={
                                      navClicked4 ? faChevronUp : faChevronDown
                                  }
                                  className="dropDownIcon"
                              />
                          </div>
                          {navClicked4 ? (
                              <p className="answer">
                                  Training slots must be reserved through an
                                  internet browser. Classes can be booked
                                  through the app or browser.
                              </p>
                          ) : (
                              <></>
                          )}
                      </div>
                      <div className="questionContainer">
                          <div className="question">
                              <p>What is your cancellation policy?</p>
                              <FontAwesomeIcon
                                  onClick={() => setNavClicked5(!navClicked5)}
                                  icon={
                                      navClicked5 ? faChevronUp : faChevronDown
                                  }
                                  className="dropDownIcon"
                              />
                          </div>
                          {navClicked5 ? (
                              <p className="answer">
                                  We do not offer refunds on our memberships or
                                  one time bookings. If you have a photoshoot
                                  booked we ask that you give us at least 24
                                  hours notice to reschedule. Please reach out
                                  to{" "}
                                  <a href="mailto:marketing@pltfrm.fit">
                                      marketing@pltfrm.fit
                                  </a>{" "}
                                  with any questions.
                              </p>
                          ) : (
                              <></>
                          )}
                      </div>
                      <div className="questionContainer">
                          <div className="question">
                              <p>Do you offer parking?</p>
                              <FontAwesomeIcon
                                  onClick={() => setNavClicked6(!navClicked6)}
                                  icon={
                                      navClicked6 ? faChevronUp : faChevronDown
                                  }
                                  className="dropDownIcon"
                              />
                          </div>
                          {navClicked6 ? (
                              <p className="answer">
                                  There is limited parking available in front of
                                  PLTFRM on a first come first serve basis. We
                                  are easily accessible by the TTC and have many
                                  paid parking options nearby.
                              </p>
                          ) : (
                              <></>
                          )}
                      </div>
                      <div className="questionContainer lastQuestion">
                          <div className="question">
                              <p>When will I receive my key pass?</p>
                              <FontAwesomeIcon
                                  onClick={() => setNavClicked7(!navClicked7)}
                                  icon={
                                      navClicked7 ? faChevronUp : faChevronDown
                                  }
                                  className="dropDownIcon"
                              />
                          </div>
                          {navClicked7 ? (
                              <p className="answer">
                                  Once you sign up for a membership and make
                                  your first booking it will take at least 24
                                  hours for your key pass to be issued. Please
                                  keep this in mind when booking your first
                                  sessions. If you are in a hurry please send an
                                  email to{" "}
                                  <a href="mailto:marketing@pltfrm.fit">
                                      marketing@pltfrm.fit
                                  </a>{" "}
                                  after making your booking and our team will do
                                  their best to ensure you are issued your pass.
                              </p>
                          ) : (
                              <></>
                          )}
                      </div>
                  </div>
              </div>
          </section>
          <section className="contactUsSection">
              <div className="wrapper">
                  <h2>Contact Us</h2>
                  <p>
                      Ready to find out if PLTFRM is your home? Get in touch
                      with us and let’s chat about what we can do for you!
                  </p>
                  <div className="contactOptions">
                      <div>
                          <a href="https://www.instagram.com/pltfrm.fit/">
                              <img src={instagram} alt="Instagram icon" />
                              <span className="sr-only sr-only-focusable">
                                  Link to Pltfrm.fit instagram
                              </span>
                          </a>
                          <h4>DM Us</h4>
                          <p>
                              Send us a message <br />
                              on instagram @pltfrm.fit
                          </p>
                      </div>
                      <div className="tourIcon">
                          <a href="https://calendly.com/pltfrm-fit/30mintour">
                              <img src={tour} alt="Tour location icon" />
                              <span className="sr-only sr-only-focusable">
                                  Link to book a tour at our location.
                              </span>
                          </a>
                          <h4>Book a tour</h4>
                          <p>
                              Visit for a free 30 minute tour to check out our
                              space.
                          </p>
                      </div>
                      <div>
                          <a href="mailto: marketing@pltfrm.fit">
                              <img src={email} alt="Email icon" />
                              <span className="sr-only sr-only-focusable">
                                  Link to send marketing@pltfrm.fit an email
                              </span>
                          </a>
                          <h4>Email us</h4>
                          <p>Send us an email at marketing@pltfrm.fit</p>
                      </div>
                  </div>
              </div>
          </section>
      </div>
  );
}

export default FAQ